var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"title primary--text mb-5"},[_vm._v(" "+_vm._s(_vm.l("Minimal App Version"))+" ")]),_c('InpageForm',{model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }